module.exports = __webpack_public_path__ + "img/7_george_s.d6aac087.png";